// let's go!
import React from 'react';
import { render } from 'react-dom';
import Routers from './components/Router'
import './css/style.css';

render(<Routers />, document.querySelector('#main'));